<template>
  <div>
    <!-- Search input -->
    <div class="row no-gutters">
      <div class="search-bar col-6 p-0">
        <input
          class="form-control-lg search py-0"
          name="searchKeyword"
          v-model="searchKeyword"
          type="text"
          :placeholder="$tc(placeholder)"
          autocomplete="off"
        />
      </div>
    </div>

    <!-- Total results label -->
    <div class="results-count pt-4 pl-3" v-show="total">
      <span id="resultsCountNumber">{{ total }}</span>
      <span id="resultsText">
        {{ $tc('nav.settings.nav.ledger.results', total) }}</span
      >
    </div>

    <!-- Ledgers list -->
    <ledger-list-list-item
      :results="ledgers"
      :attributes="attributes"
      @delete="deleteLedger"
    >
    </ledger-list-list-item>

    <!-- Pagination -->
    <core-pagination
      :page.sync="page"
      :pages.sync="pages"
      :pageSize.sync="pageSize"
      @update="getLedgers"
    ></core-pagination>
  </div>
</template>

<script>
import Ledger from '@/services/hatsApi/Ledger'

export default {
  data () {
    return {
      placeholder: 'nav.settings.nav.ledger.search-placeholder',
      attributes: ['name', 'code', 'id'],
      ledgers: [],
      total: 0,
      searchKeyword: '',
      // pagination
      page: 1,
      pages: 1,
      pageSize: 10
    }
  },
  created () {
    this.debouncedSearch = this.$_.debounce(this.getLedgers, 500)
    this.getLedgers()
  },
  watch: {
    searchKeyword: function () {
      this.debouncedSearch()
    }
  },
  methods: {
    async getLedgers () {
      try {
        let filters = [
          {
            property: 'name',
            value: this.searchKeyword
          }
        ]
        const { data } = await Ledger.getLedgers(
          filters,
          this.pageSize,
          this.page
        )
        if (this.page !== 1 && data.data.length === 0) {
          this.page = 1
          this.getLedgers()
        } else {
          this.ledgers = data.data
          this.total = data.total
          this.page = data.page
          this.pages = data.pages
        }
      } catch (e) {}
    },
    /**
     * Delete ledger by ID
     * @param {string | int} id
     * @returns {void}
     */
    async deleteLedger (id) {
      try {
        await Ledger.deleteLedger(id)
        this.getLedgers()
      } catch (e) {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ledger/Index.vue